import * as Sentry from "@sentry/react";

import { HttpError, isHttpError } from "@/shared/api/HttpError";

let pendingAuthError: HttpError | null = null;

const buffer = (error: HttpError) => {
	pendingAuthError = error;
	Sentry.addBreadcrumb({
		category: "auth",
		level: "warning",
		message: "401 buffered (no AuthProvider handler registered)",
	});
};

export const authErrorHandler: { current: (error: HttpError) => void } = {
	current: buffer,
};

export const drainPendingAuthError = (): HttpError | null => {
	const drained = pendingAuthError;
	pendingAuthError = null;
	return drained;
};

export const resetAuthErrorHandler = () => {
	authErrorHandler.current = buffer;
	pendingAuthError = null;
};

// 401-only: 403 means "logged in but not allowed" and must not redirect to login.
export const fireAuthError = (error: unknown) => {
	if (isHttpError(error) && error.status === 401) {
		authErrorHandler.current(error);
	}
};
